<template>
  <div>
    <section class="hero is-primary is-medium story-hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">
            Our Story
          </h1>
        </div>
      </div>
    </section>

    <section class="section has-text-centered is-medium">
      <div class="container">
        <h2 class="title">
          BeatCaps Origins
        </h2>
        <p class="is-size-5">
          While building an automated closed captioning solution for an online exercise streaming platform, and after trying it for ourselves, we realized the classes couldn't capture the entire experience without music. BeatCaps has the ability to turn music (sign inclusive) into rhythmic lights and or vibrations, making music accessible in more ways to be used for entertainment, exercise or dance.
        </p>
      </div>
    </section>

    <section>
      <div class="section has-background-light">
        <div class="container">
          <div class="columns">
            <div class="column is-two-thirds values-container">
              <h3 class="title is-4">
                Our Market
              </h3>
              <p class="block is-size-5">
                Entertainment for the Deaf and or Hard of Hearing teens and adults.
              </p>
              <h3 class="title is-4">
                Our Mission
              </h3>
              <p class="block is-size-5">
                We consider ourselves advocates to help creators understand their vision of a more Deaf friendly online world.
              </p>
            </div>
            <img
              src="/img/girl-with-tablet.jpg"
              alt="Girl leaning forward to reach for a tablet."
              class="column is-one-third"
            >
          </div>
        </div>
      </div>
    </section>

    <section class="section has-text-centered is-medium has-background-dark has-text-white">
      <div class="container">
        <h2 class="title">
          What Makes us Different
        </h2>
        <p class="is-size-5">
          Because BeatCaps reads the data, instead of sound, to create the visualizations or vibrations it can be used for Sign music as well. This is unlike dancing Christmas lights, or gaming systems that are used for visual appeal instead of functionality. We also plan to sell to bigger streaming companies like Youtube, Netflix, Tik Tok + so that the technology can be accessed from any device without latency.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'OurStoryPage',
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {}
}
</script>
<style>
.hero.story-hero {
  background: linear-gradient(rgba(0, 0, 0, .6), rgba(0, 0, 0, .6)), url(/img/neon-lights.jpg);
}

.values-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
